import { useState } from 'react'
import { BriefResume } from 'builder/modules/panel'

import { Steps as StepsEnum, Variant } from '../../types'
import { WelcomeStep } from './WelcomeStep/WelcomeStep'
import { WritingStep } from './WritingStep/WritingStep'
import { TemplateStep } from './TemplateStep/TemplateStep'

import * as Styles from './styles'

type Props = {
  variant: Variant
  resume?: BriefResume
  isAiResumeLoading: boolean
  onFinishClick: () => void
}

export const Steps = ({ variant, resume, isAiResumeLoading, onFinishClick }: Props) => {
  const [step, setStep] = useState<StepsEnum>(StepsEnum.WELCOME)

  const steps = {
    [StepsEnum.WELCOME]: {
      component: (
        <WelcomeStep
          step={step}
          resume={resume}
          variant={variant}
          nextStep={StepsEnum.TEMPLATE}
          isAiResumeLoading={isAiResumeLoading}
          setStep={setStep}
        />
      ),
    },
    [StepsEnum.TEMPLATE]: {
      component: (
        <TemplateStep
          step={step}
          variant={variant}
          nextStep={variant === 'c' ? StepsEnum.WRITING : undefined}
          isAiResumeLoading={isAiResumeLoading}
          setStep={setStep}
          onFinishClick={onFinishClick}
        />
      ),
    },
    [StepsEnum.WRITING]: {
      component: (
        <WritingStep
          step={step}
          variant={variant}
          setStep={setStep}
          onFinishClick={onFinishClick}
        />
      ),
    },
  }

  return (
    <Styles.Container data-testid={`onboarding-step-${step}`}>
      {steps[step].component}
    </Styles.Container>
  )
}
